import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getOrderApi } from "states/cart/cart.api";
import { OrderModel } from "states/cart/cart.models";
import "./checkout.less";
import {
  globalValueSetStepper,
  globalValueSetToast,
} from "states/global-value/global-value.action";
import {
  Stepper,
  ToastModel,
  ToastType,
} from "states/global-value/global-value.models";

interface CheckoutProps {}
interface RouteParams{
  orderId: string
}
const Checkout = (props: CheckoutProps) => {
  const dispatch = useDispatch();
  const [model, setModel] = useState({} as OrderModel);
  const params = useParams<RouteParams>();
  const _handleGetOrder = async (id: string | number) => {
    try {
      let response = await getOrderApi(id);
      document.title = "Đặt hàng thành công";
      setModel(response.data);
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  useEffect(() => {
    _handleGetOrder(params.orderId);
    dispatch(globalValueSetStepper(Stepper.Checkout));
  }, []);
  return (
    <div className="flex-container shopping-cart-container">
      <div className="checkout-info-container  p-8 ">
        <div className="panel-body text-center">
          <h3 className="p-bot-2">
            Cảm ơn bạn đã đặt hàng trên website của chúng tôi!
          </h3>
          <p>Mã đơn hàng của bạn: </p>
          <div className="well well-sm">#{model.orderNumber}</div>
          <p className="icon p-1">
            <span className="ecs-shopping-cart" />
            Bạn có thể xem lại đơn hàng
            <a href={`/account/orders/${model.id}`} style={{textDecoration:"underline"}}> tại đây</a>
          </p>
          <p>
            Thông tin chi tiết đơn hàng sẽ được gửi qua email:{" "} 
            <span><strong>{model.email}</strong></span>. Nếu không tìm thấy vui lòng kiểm tra
            trong hộp thư <strong>Spam</strong> hoặc{" "}
            <strong>Thư mục rác</strong>.
          </p>
          <div className="alert alert-success no-icon" role="alert">
            <p>
              Để giúp đẩy nhanh quá trình xử lý đơn hàng, chúng tôi sẽ gọi cho
              bạn để xác nhận đơn hàng.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Checkout;
